import React from "react";
import { GOVGR_HINT } from "../../conf/styles/GovGrTextfield";

const Hint = ({ hint, nohint }) => {
  return <>{nohint ? <></> : <p className={`${GOVGR_HINT} mt-2`}>{hint}</p>}</>;
};

export default Hint;
